import styled from "styled-components"

const StyledStrategyHeader = styled.header`
  text-align: center;
  max-width: 710px;
  margin: 0 auto 98px;
  padding: 0 16px;
  .title {
    margin: 40px 0 29px;
  }
  @media screen and (max-width: 1400px) {
    margin: 0 auto 100px;
    .title {
      margin: 30px 0 25px;
    }
  }
  @media screen and (max-width: 600px) {
    max-width: 100%;
    margin: 0 auto 80px;
    .title {
      font-size: 34px;
      line-height: 43px;
      margin: 20px 0 25px;
    }
  }
`

export default StyledStrategyHeader
